import { motion } from "framer-motion";
import "./styles.scss";
import Navbar from "./components/Navbar/navbar.component";
import Section from "./components/Section/section.component";
import Experience from "./components/Experience/experience.component";

export default function App() {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.1,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: "easeOut",
      },
    },
  };

  return (
    <div className="App">
      <motion.div
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        <motion.div variants={itemVariants}>
          <Navbar />
        </motion.div>
        <motion.div variants={itemVariants}>
          <Section />
        </motion.div>
        <motion.div variants={itemVariants}>
          <Experience />
        </motion.div>
      </motion.div>
    </div>
  );
}
